export default "__VITE_ASSET__BKIpz$xz__"